import { render, staticRenderFns } from "./AdminExpositors.vue?vue&type=template&id=ee083f9c"
import script from "./AdminExpositors.vue?vue&type=script&lang=js"
export * from "./AdminExpositors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports